import React from "react";
import { StyleSheet, useWindowDimensions, View } from "react-native";
import MobileFooterAccordion from "./mobile-footer-accordion";
import get from "lodash/get";

export default function MobileFooter({ footerData }) {
  const { width } = useWindowDimensions();
  const sections = get(footerData, "sections");
  const slicedSections = sections?.slice(0, -1);

  if (width >= 1024) {
    return null;
  }

  return (
    <View style={styles.wrapper}>
      <View style={styles.accordionWrap}>
        {slicedSections?.map((section, index) => (
          <MobileFooterAccordion
            key={index}
            title={section.title}
            links={section.links}
            index={index}
          />
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    display: "flex",
    backgroundColor: "#f3eee2",
  },
  accordionWrap: {
    borderTopColor: "#D9D2C4",
    borderTopWidth: 1,
  },
});
